// extracted by mini-css-extract-plugin
export default {"salesBox":"rRSkZ","purchaseBox":"j2n3w","salesInputs":"CtPjd","headers":"ilr6q","placeholderInput":"IZRDP","purchaseHeaders":"Rcq80","purchasesInput":"luDGk","adjustedVat":"ndCcQ"};